import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

const meses = [
  "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
  "enero", "febrero", "marzo", "abril", "mayo", "junio"
];

const ModificarLineaModal = ({ show, onClose, formState, setFormState, onSave }) => {

  const handleChange = (mes, valor) => {
    let valores = formState.valores;
    valores[mes].importe = parseFloat(valor);
    setFormState({
      ...formState,
      valores
    });
  };

  const limpiarMontos = () => {
    let valores = formState.valores;
    for(let i = 0; i < valores.length; i++) {
      valores[i].importe = valores[i].importe ? 0 : null;
    }
    setFormState({
      ...formState,
      valores
    });
  };  

  const calcularTotal = () => [0,1,2,3,4,5,6,7,8,9,10,11].reduce((acc, mes) => acc + (formState.valores[mes].importe || 0), 0);

  return formState.valores ? (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{formState?.categoria}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <div className="row">
            {meses.map((mes, index) => (
              <div className="col-4 mb-3" key={mes}>
                <Form.Label style={{ fontWeight: "bold"}}>{mes.charAt(0).toUpperCase() + mes.slice(1) + (formState.valores[index].importe ? (" " + formState.valores[index].importe.toLocaleString()) : "")}</Form.Label>
                <Form.Control
                  type="number"
                  value={formState.valores[index].importe}
                  onChange={(e) => handleChange(index, e.target.value)}
                />
              </div>
            ))}
          </div>
        </Form>
        <hr />
        <h5>Total: {calcularTotal().toLocaleString()} Gs</h5>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Cancelar</Button>
        <Button variant="warning" onClick={limpiarMontos}>Limpiar</Button>
        <Button variant="primary" onClick={() => onSave(calcularTotal())}>Guardar</Button>
      </Modal.Footer>
    </Modal>
  )
  : <></>;
};

export default ModificarLineaModal;